import { parkingState } from "../zustand/parkingState" // Adjust the import path as needed
import { performParkingSearch } from "./apiHelper"
import { FlowEnum } from "../constants/flowEnums"
const sortingHelper = {
  sort,
  handleSorting,
  amendmentSorting,
  spacesSorting,
}

export default sortingHelper

export const handleSorting = (sortingKey, changeFromBooking = undefined, history) => {
  const { allProducts } = parkingState.getState()
  switch (sortingKey) {
    case "price":
      handlePriceSorting(allProducts)
      break
    case "freeSpaces":
      handleSpacesSorting(allProducts)
      break
    case "upgradeOption":
      handleAmendmentSorting(allProducts, changeFromBooking)
      break
    case "distance":
      break
    default:
      handleSearchWithSorting(sortingKey, history)
  }
}
const handleSearchWithSorting = (sortingKey, history) => {
  const { arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode } = parkingState.getState()
  performParkingSearch(arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode, true, sortingKey, history)
}

const handlePriceSorting = (allProducts) => {
  const sortedProducts = priceSorting(allProducts)
  parkingState.setState({ allProducts: sortedProducts })
}

const handleSpacesSorting = (allProducts) => {
  const sortedProducts = spacesSorting(allProducts)
  parkingState.setState({ allProducts: sortedProducts })
}

const handleAmendmentSorting = (allProducts, cfProduct = undefined) => {
  const sortedProducts = amendmentSorting(allProducts, cfProduct)
  parkingState.setState({ allProducts: sortedProducts })
}

const priceSorting = (allProducts) => {
  return allProducts.sort((a, b) => a.result.totalPrice - b.result.totalPrice)
}

export const spacesSorting = (allProducts) => {
  return allProducts.sort((a, b) => a.product.isSoldOut - b.product.isSoldOut)
}

export const sort = (sortingKey, allProducts, cfProduct = undefined) => {
  switch (sortingKey) {
    case "price":
      return priceSorting(allProducts)
    case "freeSpaces":
      return spacesSorting(allProducts)
    case "amendmentSort":
      return amendmentSorting(allProducts, cfProduct)
    case "distance":
      break
    default:
      break
  }
  return allProducts
}

export const amendmentSorting = (allProducts, cfProduct) => {
  if (parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOWCHANGECARPARK) {
    let hasExtras = false
    hasExtras = cfProduct.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
    let extrasAmount = 0
    if (hasExtras) {
      extrasAmount = cfProduct.booking.items.extras[0].offerLines[0].amount
    }

    let positiveProducts = allProducts.filter(
      (x) =>
        (x.result.memberPrice > 0 ? x.result.memberPrice : x.result.totalPrice) - (cfProduct.booking.price - extrasAmount) >= 0 &&
        !x.product.isSoldOut,
    )
    positiveProducts = positiveProducts.sort((a, b) => {
      return (a.result.memberPrice > 0 ? a.memberPrice : a.result.totalPrice) - b.result.totalPrice
    })

    let negativeProducts = allProducts.filter(
      (x) =>
        (x.result.memberPrice > 0 ? x.result.memberPrice : x.result.totalPrice) - (cfProduct.booking.price - extrasAmount) < 0 &&
        !x.product.isSoldOut,
    )
    negativeProducts = negativeProducts
      .sort((a, b) => {
        return (a.result.memberPrice > 0 ? a.memberPrice : a.result.totalPrice) - b.result.totalPrice
      })
      .reverse()

    let stocklessProducts = allProducts.filter((x) => x.product.isSoldOut)
    stocklessProducts = stocklessProducts.sort((a, b) => {
      return (a.result.memberPrice > 0 ? a.memberPrice : a.result.totalPrice) - b.result.totalPrice
    })

    const emulsifiedProductList = positiveProducts.concat(negativeProducts, stocklessProducts)

    return emulsifiedProductList
  }
  return allProducts
}
